function queryToUrl(query: object) {
  return Object.keys(query).map(key => `${key}=${(query as any)[key]}`).join('&')
}

export const useHttp = async <T = any>(
  url: string,
  {
    method = 'get',
    body,
    fileDownload = false,
    spinner = true,
    contentType
  }: {
    method?: 'get' | 'post' | 'put' | 'delete'
    body?: object | string
    fileDownload?: boolean
    spinner?: boolean
    contentType?: string
  } = {}
): Promise<T> => {
  const headers = { 'content-type': contentType ?? (fileDownload ? 'application/octet-stream' : 'application/json') }
  const loadingIndicator = useLoadingIndicator()

  if (spinner)
    loadingIndicator?.start()
  try {
    const { apiUrl } = useRouterStore()
    const localUrl = method === 'get' && body && typeof body === 'object' && Object.keys(body).length > 0
      ? `${url}/?${queryToUrl(body)}`
      : url
    const localBody = method === 'get' ? undefined : (typeof body === 'string' ? body : JSON.stringify(body ?? {}))
    const responseType = fileDownload ? 'blob' : 'json'
    return await useHttpApi<T>(localUrl, {
      baseURL: apiUrl,
      method,
      body: localBody,
      headers,
      responseType
    }) as T
  } catch (e: any) {
    const errorMessage = fileDownload
      ? JSON.parse(await e.response?._data.text())?.error || 'Falha no download do arquivo'
      : e?.response?._data?.error || 'Falha de conexão com o servidor'
    useMessage().showError(errorMessage)
    const status = e?.response?.status ?? 0
    if (status === 401)
      useAuthStore().signOut()
    const err: Error & { statusCode?: number, isNetworkError?: boolean } = new Error(errorMessage)
    err.statusCode = status
    err.isNetworkError = !e?.response
    throw err
  } finally {
    if (spinner)
      loadingIndicator?.finish()
  }
}
